import type { TrKey } from '@esnafai/shared/i18n';
import {
  Bell,
  Bot,
  Hourglass,
  House,
  Images,
  Inbox,
  Package,
  Plug,
  Settings,
  ShoppingBag,
  ChartColumn,
  Users,
  type LucideIcon,
} from 'lucide-react';

// The navigation of merchant screens §2: the bottom bar's four areas, the rest behind Diğer, all of them in the
// sidebar. No area is Owner-only as a whole (only some tabs are), so every item shows to both roles.
export type NavEntry = {
  id: string;
  to: string;
  label: TrKey;
  icon: LucideIcon;
};

export const primaryNav: readonly NavEntry[] = [
  { id: 'home', to: '/', label: 'nav.home', icon: House },
  { id: 'inbox', to: '/inbox', label: 'nav.inbox', icon: Inbox },
  { id: 'waiting', to: '/waiting', label: 'nav.waiting', icon: Hourglass },
  { id: 'products', to: '/products', label: 'nav.products', icon: Package },
];

export const moreNav: readonly NavEntry[] = [
  { id: 'shoppers', to: '/shoppers', label: 'nav.shoppers', icon: Users },
  { id: 'content', to: '/content', label: 'nav.content', icon: Images },
  { id: 'sales', to: '/sales', label: 'nav.sales', icon: ShoppingBag },
  { id: 'reports', to: '/reports', label: 'nav.reports', icon: ChartColumn },
  { id: 'ai', to: '/ai', label: 'nav.ai', icon: Bot },
  { id: 'integrations', to: '/integrations', label: 'nav.integrations', icon: Plug },
  { id: 'settings', to: '/settings', label: 'nav.settings', icon: Settings },
  { id: 'notifications', to: '/notifications', label: 'nav.notifications', icon: Bell },
];
